import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BazisInputNumberComponent } from '@bazis/form/components/base/inputs/input-number.component';

@UntilDestroy()
@Component({
    selector: 'bazis-input-number-buttons',
    templateUrl: './input-number-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisInputNumberButtonsComponent extends BazisInputNumberComponent {}
